import Hashes from 'jshashes'

export const MD5 = new Hashes.MD5()
export const SHA1 = new Hashes.SHA1()
export const SHA256 = new Hashes.SHA256()



// WEBPACK FOOTER //
// ./src/utils/hash.js